import { useEffect, useState } from 'react';
import { escucharHecho } from '../lib/hecho.js';
import { Ico } from './Iconos.js';

/** How long it stays: long enough to read twice, short enough not to be in the way. */
const DURA_MS = 4_000;

/**
 * What a finished task said as it went back where it began (`lib/hecho.ts`): a line at the top of
 * the screen for a few seconds, read out once by a screen reader. It sits over the header, where
 * «Volver» and the house are, so it takes no taps: whatever is under it still answers the first.
 */
export function Hecho() {
  const [hecho, setHecho] = useState<{ texto: string; vez: number } | null>(null);
  useEffect(() => escucharHecho((texto) => setHecho((h) => ({ texto, vez: (h?.vez ?? 0) + 1 }))), []);
  useEffect(() => {
    if (!hecho) return;
    const reloj = setTimeout(() => setHecho(null), DURA_MS);
    return () => clearTimeout(reloj);
  }, [hecho]);

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-[max(env(safe-area-inset-top),0.75rem)] z-[60] flex justify-center px-4"
    >
      {hecho && (
        <p
          key={hecho.vez}
          className="aparece flex max-w-md items-center gap-2 rounded-2xl bg-emerald-950 px-4 py-2.5 text-sm font-medium text-emerald-100 shadow-lg ring-1 ring-emerald-500/30 ring-inset"
          data-hecho
        >
          <Ico icono="listo" className="size-4 shrink-0 text-emerald-300" />
          {hecho.texto}
        </p>
      )}
    </div>
  );
}
